export default defineNuxtPlugin((nuxtApp) => {
  const { latestBuildId } = useLatestBuild();
  const router = useRouter();
  const chunkErrors = new Set<unknown>();

  // Nuxt ne l'appelle que si l'identifiant publié diffère de celui de la build qui tourne.
  nuxtApp.hook('app:manifest:update', (meta) => {
    if (meta) { latestBuildId.value = meta.id; }
  });

  // `emitRouteChunkError: 'manual'` retire aussi le rechargement qui rattrape un chunk supprimé par
  // la mise en ligne : sans lui, la navigation vers une route pas encore chargée échoue en silence.
  router.beforeEach(() => { chunkErrors.clear(); });
  nuxtApp.hook('app:chunkError', ({ error }) => { chunkErrors.add(error); });
  router.onError((error, to) => {
    if (chunkErrors.has(error)) { reloadNuxtApp({ path: to.fullPath, persistState: true }); }
  });
});
